import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FC, ReactNode } from 'react';
import { AxiosError } from 'axios';

const shouldUseErrorBoundary = (error: unknown) => {
  if (error instanceof AxiosError) {
    return error.response?.status ? error.response.status >= 500 : false;
  } else {
    return true;
  }
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      retry: false,
      useErrorBoundary: shouldUseErrorBoundary,
    },
    mutations: {
      useErrorBoundary: shouldUseErrorBoundary,
    },
  },
});
interface ReactQueryClientProviderProps {
  children?: ReactNode;
}

export const ReactQueryClientProvider: FC<ReactQueryClientProviderProps> = ({
  children,
}) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
